/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Badge_PushedInputs */

const vi_einvoice_badge_pushed = /** @type {(inputs: Einvoice_Badge_PushedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã gửi MISA · Chưa phát hành`)
};

/**

* @param {Einvoice_Badge_PushedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_badge_pushed = /** @type {((inputs?: Einvoice_Badge_PushedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Badge_PushedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_badge_pushed(inputs)
});